import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 18a2 2 0 1 0 4 0a2 2 0 1 0 -4 0","key":"svg-0"}],["path",{"d":"M4 6a2 2 0 1 0 4 0a2 2 0 1 0 -4 0","key":"svg-1"}],["path",{"d":"M16 18a2 2 0 1 0 4 0a2 2 0 1 0 -4 0","key":"svg-2"}],["path",{"d":"M6 8v8","key":"svg-3"}],["path",{"d":"M18 11h.01","key":"svg-4"}],["path",{"d":"M18 6h.01","key":"svg-5"}]]

const IconGitPullRequestDraft = createReactComponent('outline', 'git-pull-request-draft', 'GitPullRequestDraft', __iconNode);

export default IconGitPullRequestDraft;